module.exports = __webpack_public_path__ + "static/img/banner.70a23239.png";